export default __webpack_public_path__ + "static/stanleyknife-79e0c8ebc5df777b3853bf346a29cb3f.png";